<template>
  <div
    class="answer-box" v-bind:class="{ active }"
  >
    <span
      class="answer-box__field"
      v-bind:class="{ 'answer-box__field_empty': isEmpty }"
      v-on:click="focusInput"
    >
      <input ref="inputField" type="text" v-model="localValue" />
      <span class="question-number__wrapper">
        <span class="question-number">{{ questionNumber }}</span>
      </span>
      <span
        class="answer-box__bet-icon"
        v-bind:class="{ active: hasBet }"
        v-if="showBet"
        v-on:click="toggleBet"
      >+2</span>
    </span>
    <span class="answer-box__modifier" v-if="showFunny">
      <button class="answer-box__smile-icon"
        v-bind:class="{ active: hasFunny }"
        v-on:click="toggleFunny"
      >
      </button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'AnswerBox',

  props: {
    active: {
      type: Boolean,
      default: false,
    },

    value: {
      type: String,
      default: '',
    },

    showFunny: {
      type: Boolean,
      default: true,
    },

    hasFunny: {
      type: Boolean,
      default: false,
    },

    showBet: {
      type: Boolean,
      default: false,
    },

    hasBet: {
      type: Boolean,
      default: false,
    },

    questionNumber: {
      type: Number,
      required: true,
    },
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      },
    },

    isEmpty() {
      return this.localValue.length <= 0;
    },
  },

  methods: {
    focusInput() {
      this.$refs.inputField.focus();
    },

    toggleBet() {
      this.$emit('toggleBet');
    },

    toggleFunny() {
      this.$emit('toggleFunny');
    },
  },
};
</script>
